import { IJsonSerializable } from "../util/interfaces"

import { OpCurrentCreditInfo } from "./op-current-credit-info"
import { OpCurrency } from "../core/op-currency"
import { OpEmergencyCreditInfo } from "./op-emergency-credit-info"


export class OpCreditInfo implements IJsonSerializable {

    // Properties 

    public currentCreditInfo: OpCurrentCreditInfo
    public emergencyCreditInfo: OpEmergencyCreditInfo
    public currency: OpCurrency

    // Properties End


    // Ctor

    public constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End

    
    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false) {
        if (opObj != null) {
            this.currentCreditInfo = opObj.CurrentCreditInfo != null ? new OpCurrentCreditInfo(opObj.CurrentCreditInfo) : null
            this.emergencyCreditInfo = opObj.EmergencyCreditInfo != null ? new OpEmergencyCreditInfo(opObj.EmergencyCreditInfo) : null
            this.currency = opObj.Currency != null ? new OpCurrency(opObj.Currency) : null
        }
    }

    public toJSON(compressed: boolean = false) {
        return {
            CurrentCreditInfo: this.currentCreditInfo != null ? this.currentCreditInfo.toJSON() : null,
            EmergencyCreditInfo: this.emergencyCreditInfo != null ? this.emergencyCreditInfo.toJSON() : null,
            Currency: this.currency != null ? this.currency.toJSON() : null,
        }
    }

    // IJsonSerializable Implementation End
}